export default __webpack_public_path__ + "static/media/classes-active.dde87b3e.svg";